import Component from '../colorz/Component';

import device from '../colorz/utils/device';
import Flickity from 'flickity-imagesloaded';

import stylizer from '../colorz/utils/stylizer';

module.exports = class KeyDates extends Component {
    onInit( el, args) {
        // Initializations
        this.onClick = this.onClick.bind( this );

        this.el = el;
        this.tabContainer = this.el.querySelector('.keydate__list');
        this.tabContent = this.el.querySelectorAll('.js-tab-content');
        this.tabList = this.el.querySelectorAll('.js-tab');
        this.active = 0;
    }

    onReady() {
        this.setActive();

        if ( device.width < 1080 ) {
            this.initSlider();
        }

        for (let i = 0; i < this.tabList.length; i++){
            this.tabList[i].addEventListener(device.pointerdown, this.onClick);
        }
    }

    onClick(e) {
        this.unsetActive();

        if (this.tabContainer.contains(e.target)){
            this.active = e.target.dataset.id;
        }

        this.setActive();
    }

    setActive(){
        for (let i = 0; i < this.tabContent.length; i ++){
            if (this.tabContent[i].dataset.id == this.active) {
                this.tabContent[i].classList.add('is-active');
            }
        }

        let isActivePassed = false;
        for( let i = 0 ; i < this.tabList.length ; i++ ) {
            this.tabList[i].classList.remove( 'is-before' );
            this.tabList[i].classList.remove( 'is-after' );

            if( !isActivePassed && i != this.active ) {
                this.tabList[i].classList.add( 'is-before' );
            }
            else if( i == this.active ) {
                isActivePassed = true;
            }
            else if( isActivePassed && i != this.active ) {
                this.tabList[i].classList.add( 'is-after' );
            }
        }
    }

    unsetActive(){
        for (let i = 0; i < this.tabContent.length; i ++){
            this.tabContent[i].classList.remove('is-active');
        }
    }

    initSlider(){
        // var options = {
        //     cellSelector: '.js-tab',
        //     pageDots: false,
        //     cellAlign : 'left',
        //     prevNextButtons: false,
        //     wrapAround: false,
        //     imagesLoaded: true,
        //     draggable: true
        // };

        // // init slider
        // this.slider = new Flickity(this.el, options);

        let fakeItem = document.querySelector('.fakeitem');

        for( let i = 0 ; i < this.tabList.length ; i++ ) {
            stylizer.transform( this.tabList[i], 'translateX(' + (( 45 + 20 ) * i) +'px)' );
        }

        stylizer.transform( fakeItem, 'translateX(' + (( 45 + 20 ) * this.tabList.length) +'px)' );
    }
};